const buildStorageKey = (draftType, itemId) =>
  `kanban_item_draft:${draftType}:${itemId}`;

export const loadItemDraft = (draftType, itemId) => {
  if (typeof window === 'undefined' || !window.localStorage || !itemId) {
    return null;
  }

  try {
    const storedValue = window.localStorage.getItem(
      buildStorageKey(draftType, itemId)
    );

    return storedValue ? JSON.parse(storedValue) : null;
  } catch {
    return null;
  }
};

export const saveItemDraft = (draftType, itemId, draftValue) => {
  if (typeof window === 'undefined' || !window.localStorage || !itemId) {
    return;
  }

  try {
    window.localStorage.setItem(
      buildStorageKey(draftType, itemId),
      JSON.stringify(draftValue)
    );
  } catch {
    // Ignore browser storage failures and keep the in-memory draft.
  }
};

export const clearItemDraft = (draftType, itemId) => {
  if (typeof window === 'undefined' || !window.localStorage || !itemId) {
    return;
  }

  try {
    window.localStorage.removeItem(buildStorageKey(draftType, itemId));
  } catch {
    // Ignore browser storage failures.
  }
};
